import React from 'react';
import { OptionsPlaceholderPage } from '../../components/options/OptionsPlaceholderPage';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';

export default function OptionsHoldings() {
  const { t } = useOptionsLocale();
  return (
    <OptionsPlaceholderPage
      title={t('placeholders.holdings.title')}
      description={t('placeholders.holdings.description')}
      eyebrow={t('placeholders.holdings.eyebrow')}
      placeholderTitle={t('placeholders.holdings.placeholderTitle')}
      placeholderDescription={t('placeholders.holdings.placeholderDescription')}
      bullets={t('placeholders.holdings.bullets')}
    />
  );
}